<div class="grid-container">
    <mat-card class="grid-bulletin mat-elevation-z3">
        <mat-card-header class="hasSubHeader">
            <div mat-card-avatar>
                <mat-icon aria-hidden="false" aria-label="Bullhorn icon">campaign</mat-icon>
            </div>
            <mat-card-title>Latest Bulletin</mat-card-title>
            <mat-card-subtitle>{{ bulletin?.title ? bulletin?.title : '[MISSING TITLE]'}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <ng-container *ngIf="!loadingBulletins; else loadBulletin">
                <editor [disabled]="true" [init]="config | cssType: bulletin.type" [(ngModel)]="bulletin.message"> </editor>
                <div>
                    <!-- {{bulletin | json}} -->
                    <ul class="bulletin-details">
                        <li><strong>Start Date</strong>: {{ bulletin?.startDate | date: 'short' }} <br /></li>
                        <li><strong>End Date</strong>: {{ bulletin?.endDate | date: 'short' }}</li>
                        <li fxLayout="row" style="align-items: center">
                            <strong style="padding-right: 10px">Status: </strong>
                            <mat-chip-list aria-label="Fish selection" selectable="false">
                                <mat-chip chipListSelectable="false" [class.bulletinActive]="bulletin?.active">
                                    {{ bulletin?.active ? 'Active' : 'Inactive' }}</mat-chip
                                >
                                <mat-chip chipListSelectable="false" class="bulletinLive" *ngIf="bulletinLive">Live </mat-chip>
                            </mat-chip-list>
                        </li>
                    </ul>
                </div>
            </ng-container>
            <ng-template #loadBulletin> Loading... </ng-template>
        </mat-card-content>
    </mat-card>

    <mat-card class="grid-hof mat-elevation-z3">
        <mat-card-header>
            <div mat-card-avatar>
                <mat-icon aria-hidden="false" aria-label="Trophy icon">emoji_events</mat-icon>
            </div>
            <mat-card-title>Hall of Fame</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ng-container *ngIf="!loadingHOF; else loadHOF">
                <mat-list role="list">
                    <mat-list-item role="listitem" *ngFor="let member of hallOfFames">{{ member }}</mat-list-item>
                </mat-list>
            </ng-container>
            <ng-template #loadHOF> Loading... </ng-template>
        </mat-card-content>
        <mat-card-actions>
            <a mat-flat-button color="primary" [routerLink]="'/' + RoutePath.HallOfFame" routerLinkActive="active"
                >View Hall of Fame</a
            >
        </mat-card-actions>
    </mat-card>

    <mat-card class="grid-events mat-elevation-z3">
        <mat-card-header>
            <div mat-card-avatar>
                <mat-icon aria-hidden="false" aria-label="Calendar icon">event</mat-icon>
            </div>
            <mat-card-title>Recent Events Added</mat-card-title>
            <!-- <mat-card-subtitle>Dog Breed</mat-card-subtitle> -->
        </mat-card-header>
        <mat-card-content>
            <ng-container *ngIf="!loadingEvents; else loadEvents">
                <mat-list role="list">
                    <mat-list-item role="listitem" *ngFor="let event of events">{{ event.eventName }}</mat-list-item>
                </mat-list>
            </ng-container>
            <ng-template #loadEvents> Loading... </ng-template>
        </mat-card-content>
        <mat-card-actions>
            <a mat-flat-button color="primary" [routerLink]="'/' + RoutePath.Events" routerLinkActive="active">View Events</a>
        </mat-card-actions>
    </mat-card>

    <mat-card class="grid-eventDetails mat-elevation-z3">
        <mat-card-header>
            <div mat-card-avatar>
                <mat-icon aria-hidden="false" aria-label="Calendar icon">event_note</mat-icon>
            </div>
            <mat-card-title>Recent Dates Added</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ng-container *ngIf="!loadingDetails; else loadDetails">
                <mat-list role="list">
                    <mat-list-item role="listitem" *ngFor="let detail of details">
                        <strong style="padding-right: 10px">{{ detail.eventName }}:</strong> {{ detail.startDate | date: 'short' }} -
                        {{ detail.endDate ? (detail.endDate | date: 'short') : 'ALL DAY' }}
                    </mat-list-item>
                </mat-list>
            </ng-container>
            <ng-template #loadDetails> Loading... </ng-template>
        </mat-card-content>
    </mat-card>

    <mat-card class="grid-feeds mat-elevation-z3">
        <mat-card-header>
            <div mat-card-avatar>
                <mat-icon aria-hidden="false" aria-label="Trophy icon">rss_feed</mat-icon>
            </div>
            <mat-card-title>Calendar Feeds</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <mat-list role="list">
                <mat-list-item role="listitem"><a href="/api/feeds/calendar?type=full">Full Calendar Feed</a> </mat-list-item>
                <mat-list-item role="listitem"><a href="/api/feeds/calendar?type=traditional">Traditional Feed</a> </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>
</div>
